import { useEffect, useState } from "react"

// CSS `background-image` has no load-failure event of its own, so a banner
// URL that 403s (e.g. an S3 object outside the current domain's whitelist)
// just renders as blank instead of falling back — even though the banner
// API call itself succeeded. This preloads `url` with a throwaway <img> and
// resolves to `fallbackUrl` if it fails to load, so callers can bind the
// resolved value straight to backgroundImage.
const useImageWithFallback = (url, fallbackUrl) => {
  const [resolvedUrl, setResolvedUrl] = useState(url || fallbackUrl)

  useEffect(() => {
    if (!url) {
      setResolvedUrl(fallbackUrl)
      return undefined
    }
    let cancelled = false
    const img = new Image()
    img.onload = () => {
      if (!cancelled) setResolvedUrl(url)
    }
    img.onerror = () => {
      if (!cancelled) setResolvedUrl(fallbackUrl)
    }
    img.src = url
    return () => {
      cancelled = true
    }
  }, [url, fallbackUrl])

  return resolvedUrl
}

export default useImageWithFallback
